import {createStore} from 'redux'
import {useSelector, Provider} from 'react-redux'
import MuiAlert from '@material-ui/lab/Alert';
import {Snackbar} from "@material-ui/core";

const snackbarReducer = (state = {message: '', open: false, severity: 'error'}, action) => {
  const props = {message: action?.message, open: true}
  switch (action.type) {
    case 'snackbar/close':
      return {...state, open: false}
    case 'snackbar/error':
      return {...props, severity: 'error'}
    case 'snackbar/info':
      return {...props, severity: 'info'}
    case 'snackbar/success':
      return {...props, severity: 'success'}
    default:
      return state
  }
}

export const snackbarStore = createStore(snackbarReducer)

export const snackbarInfo = (message) => snackbarStore.dispatch({type: 'snackbar/info', message})
export const snackbarError = (message) => snackbarStore.dispatch({type: 'snackbar/error', message})
export const snackbarSuccess = (message) => snackbarStore.dispatch({type: 'snackbar/success', message})

export const SnackbarReduxWrapper = () =>
  <Provider store={snackbarStore}>
    <MySnackbar/>
  </Provider>

const MySnackbar = () => {
  const snackbarState = useSelector(state => state)
  const closeHandler = (event, reason) => {
    if (reason !== 'clickaway') snackbarStore.dispatch({type: 'snackbar/close'})
  }
  return (
    <Snackbar open={snackbarState.open}
              autoHideDuration={5000}
              onClose={closeHandler}
              anchorOrigin={{horizontal: 'center', vertical: 'top'}}>
      <MuiAlert
        elevation={6}
        variant='filled'
        onClose={closeHandler}
        severity={snackbarState.severity}>
        {snackbarState.message}
      </MuiAlert>
    </Snackbar>
  )
}
